import {Component, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ReplaySubject} from 'rxjs';
import {StepScreenModel} from '../../../../shared/step/step-screen.component';
import {Ecfmg} from '../../../../../domain/model/education/ecfmg/ecfmg.model';
import {FormErrors} from '../../../../../components/forms/validation/form-validator.class';
import {EcfmgService} from '../../../../../domain/model/education/ecfmg/ecfmg.service';
import {FileLocationFactory} from '../../../../../components/files/service/file-location.class';
import {Model} from '../../../../../domain/model/common/model.class';
import {MonthPickerComponentModel} from '../../../../../components/forms/controls/monthpicker/month-picker.component';
import moment = require('moment');
import ProjectionInformation = Model.ProjectionInformation;
import {VerificationService} from '../../../../../components/verification/service/verification.service';

@Component({
    template: require('./ecfmg-screen.component.html')
})
export class EcfmgScreenComponent {

    constructor(
        readonly educationService: EcfmgService,
        readonly fileLocationFactory: FileLocationFactory,
        readonly verificationService: VerificationService,
    ) {}

    // region Form
    readonly form$ = new ReplaySubject<NgForm>(1);

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    // endregion

    dateIssuedMonthPickerModel = new MonthPickerComponentModel({
        minDate: moment().subtract(100, 'year'),
        maxDate: moment().add(5, 'year')
    });
    // TODO could be created by corresponding service
    proofDocumentFileLocation = this.fileLocationFactory.create('ecfmg', 'currentUser', new ProjectionInformation('proofDocument'));

    stepScreenModel = new StepScreenModel<Ecfmg>({
        initialDataModel: new Ecfmg(),
        specificValidationMessages: {},
        _loadDataFn: () => {
            this.verificationService.setUrl('ecfmg');
            return this.educationService.getCurrentUserModel();
        },
        _submitDataFn: (model: Ecfmg) => {
            return this.educationService.updateCurrentUserModel(model);
        }
    });

    get model(): Ecfmg {
        return this.stepScreenModel.dataModel;
    }

    get formErrors(): FormErrors {
        return this.stepScreenModel.formErrors;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/education/steps/premedical/ecfmg/ecfmg-screen.component.ts